<template>
  <section class="service-workflow">
    <div class="service-workflow-inner">
      <h2 class="workflow-title">How Our Service Works?</h2>
      <div class="workflow-steps">
        <div v-for="(step, index) in steps" :key="index" class="workflow-step">
          <div class="step-icon">
            <img class="icon-default" :src="step.icon" :alt="step.title">
            <img class="icon-active" :src="step.activeIcon" :alt="step.title">
          </div>
          <div class="step-title">{{ step.title }}</div>
          <div class="step-desc" v-if="step.desc" :class="{ highlight: step.highlight }">
            {{ step.desc }}
          </div>
          <div v-if="index < steps.length - 1" class="step-arrow">-&gt;</div>
        </div>
      </div>
      <div class="workflow-footer">
        <div class="delivery-info">
          <div class="years-badge">
            <span class="years-number">20</span>
            <span class="years-text">years</span>
          </div>
          <div class="worldwide-content">
            <div class="worldwide-title">Worldwide delivery</div>
            <div class="worldwide-desc">BuybuyGENUINE supplies new OEM (genuine) parts and ships worldwide with fast
              delivery and reasonable cost to the customer.</div>
          </div>
        </div>
        <div class="paypal-wrap">
          <img class="paypal-logo paypal-default" src="@/assets/编组(21).png" alt="PayPal">
          <img class="paypal-logo paypal-active" src="@/assets/编组备份 5.png" alt="PayPal">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiceWorkflow',
  data() {
    return {
      steps: [
        {
          title: 'Create your order',
          desc: 'How to buy?',
          icon: require('@/assets/编组(17).png'),
          activeIcon: require('@/assets/cart1.png'),
          highlight: true
        },
        {
          title: 'Suppliers are contacted',
          desc: 'Manufacturers as well',
          icon: require('@/assets/编组(19).png'),
          activeIcon: require('@/assets/编组(8).png'),
          highlight: false
        },
        {
          title: 'We receive your items',
          desc: 'At our warehouse',
          icon: require('@/assets/编组(14).png'),
          activeIcon: require('@/assets/编组(4).png'),
          highlight: false
        },
        {
          title: 'Pay delivery fee',
          desc: '',
          icon: require('@/assets/编组(15).png'),
          activeIcon: require('@/assets/编组(5).png'),
          highlight: false
        },
        {
          title: 'Your order is shipped',
          desc: 'Safely packed',
          icon: require('@/assets/编组(16).png'),
          activeIcon: require('@/assets/编组(6).png'),
          highlight: false
        },
        {
          title: 'Delivered!',
          desc: '',
          icon: require('@/assets/编组(20).png'),
          activeIcon: require('@/assets/编组(9).png'),
          highlight: false
        }
      ]
    }
  }
}
</script>

<style scoped>
.service-workflow {
  width: 100%;
  padding: 0 20px 42px;
  background-color: #fff;
}

.service-workflow-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.workflow-title {
  margin: 0 0 42px;
  color: #222;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.workflow-steps {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
}

.workflow-step {
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-icon {
  width: 82px;
  height: 82px;
  margin-bottom: 18px;
  position: relative;
}

.step-icon img {
  width: 82px;
  height: 82px;
  display: block;
  object-fit: contain;
  transition: opacity 0.18s;
}

.icon-active {
  position: absolute;
  inset: 0;
  opacity: 0;
}

.workflow-step:hover .icon-default {
  opacity: 0;
}

.workflow-step:hover .icon-active {
  opacity: 1;
}

.step-title {
  min-height: 20px;
  color: #333;
  font-size: 15px;
  line-height: 1.35;
}

.step-desc {
  margin-top: 6px;
  color: #8d8d8d;
  font-size: 14px;
  line-height: 1.35;
}

.step-desc.highlight {
  color: #ff5a1f;
}

.step-arrow {
  position: absolute;
  top: 24px;
  right: -25px;
  color: #aaa;
  font-size: 28px;
  font-weight: 300;
}

.workflow-footer {
  margin-top: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delivery-info {
  display: flex;
  align-items: center;
  gap: 22px;
  max-width: 620px;
}

.years-badge {
  width: 70px;
  height: 70px;
  border: 2px solid #ff5a1f;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ff5a1f;
  flex: 0 0 auto;
}

.years-number {
  font-size: 26px;
  font-weight: 400;
  line-height: 1;
}

.years-text {
  font-size: 14px;
  line-height: 1;
}

.worldwide-title {
  margin-bottom: 8px;
  color: #333;
  font-size: 18px;
  font-weight: 700;
  transition: color 0.18s;
}

.worldwide-desc {
  color: #555;
  font-size: 12px;
  line-height: 1.45;
  transition: color 0.18s;
}

.delivery-info:hover .worldwide-title,
.delivery-info:hover .worldwide-desc {
  color: #ff5a1f;
}

.paypal-wrap {
  width: 201px;
  height: 49px;
  position: relative;
}

.paypal-logo {
  width: 201px;
  height: 49px;
  display: block;
  object-fit: contain;
  transition: opacity 0.18s;
}

.paypal-active {
  position: absolute;
  inset: 0;
  opacity: 0;
}

.paypal-wrap:hover .paypal-default {
  opacity: 0;
}

.paypal-wrap:hover .paypal-active {
  opacity: 1;
}

@media (max-width: 992px) {
  .workflow-steps {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 42px;
  }

  .step-arrow {
    display: none;
  }
}

@media (max-width: 640px) {
  .workflow-steps {
    grid-template-columns: 1fr;
  }

  .workflow-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 28px;
  }
}
</style>
